import { STATUS } from "@/data/portal";

export const StatusBadge = ({ status, testid }) => {
  const s = STATUS[status] || { label: status, cls: "bg-slate-100 text-slate-700 border-slate-300" };
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold ${s.cls}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {s.label}
    </span>
  );
};
